import {
  OperationVariables,
  DocumentNode,
  TypedDocumentNode,
  QueryResult,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction,
  LazyQueryResultTuple,
  useQuery as useQueryOrigin,
  useLazyQuery as useLazyQueryOrigin,
  NoInfer
} from '@apollo/client';

export const useQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<NoInfer<TData>, NoInfer<TVariables>>
): QueryResult<TData, TVariables> => {
  const ret = useQueryOrigin(query, options);

  if (ret.error) {
    throw ret.error;
  }

  return ret;
};

export const useLazyQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: LazyQueryHookOptions<NoInfer<TData>, NoInfer<TVariables>>
): LazyQueryResultTuple<TData, TVariables> => {
  const [originFetcher, result] = useLazyQueryOrigin(query, options);

  const fetcher: LazyQueryExecFunction<TData, TVariables> = async options => {
    const result = await originFetcher(options);

    if (result.error) {
      throw result.error;
    }

    return result;
  };

  return [fetcher, result];
};
